module.exports = __webpack_public_path__ + "img/locksmith.4070806b.png";